import { Configuration } from "../../entity/configuration";

export class ConfigurationTransformer {
    transform(configurationInfo: any) : Configuration {
        return new Configuration(
            configurationInfo.googleKey,
            parseFloat(configurationInfo.googleZoom),
            parseFloat(configurationInfo.lookupRadius),
            configurationInfo.merchantId
        )
    }
}